import { render, staticRenderFns } from "./grid-item-kynorelle-05.vue?vue&type=template&id=0023844f&scoped=true&"
import script from "./grid-item-kynorelle-05.vue?vue&type=script&lang=js&"
export * from "./grid-item-kynorelle-05.vue?vue&type=script&lang=js&"
import style0 from "./grid-item-kynorelle-05.vue?vue&type=style&index=0&id=0023844f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023844f",
  null
  
)

export default component.exports